<ng-container *ngIf="upload">
    <div class="upload-file">
        <ng-container
            *ngIf="
                upload.previouslyCompleted || (upload.progress && upload.progress() == 1);
                else uploadUnfinishedRef
            "
        >
            <ng-container *ngTemplateOutlet="uploadFinishedRef"></ng-container>
        </ng-container>

        <ng-template #uploadFinishedRef>
            <div class="file-info">
                <div class="file-name">{{ upload.name }}</div>
                <div class="upload-controls">
                    <img src="assets/icons/upload-done.svg" alt="Upload finished" />
                </div>
            </div>
            <div class="file-size">{{ upload.size | fileSize }} / {{ upload.size | fileSize }}</div>
            <app-upload-progress-bar [progress]="1"></app-upload-progress-bar>
        </ng-template>

        <ng-template #uploadUnfinishedRef>
            <div class="file-info">
                <div class="file-name">{{ upload.name }}</div>
                <div class="upload-controls">
                    <ng-container *ngIf="upload.paused; else uploadInProgressRef">
                        <button class="icon-button" (click)="upload.resume?.()">
                            <img src="assets/icons/upload-resume.svg" alt="Resume upload" />
                        </button>
                    </ng-container>
                    <ng-template #uploadInProgressRef>
                        <button class="icon-button" (click)="upload.pause?.()">
                            <img src="assets/icons/upload-pause.svg" alt="Pause upload" />
                        </button>
                    </ng-template>
                    <button
                        class="icon-button"
                        (click)="uploadService.cancelFileUpload(upload.uniqueIdentifier!)"
                    >
                        <img src="assets/icons/upload-cancel.svg" alt="Cancel upload" />
                    </button>
                </div>
            </div>
            <div class="file-size">
                {{ upload.size * (upload.progress?.() ?? 0) | fileSize }} /
                {{ upload.size | fileSize }}
            </div>
            <app-upload-progress-bar [progress]="upload.progress?.()"></app-upload-progress-bar>
        </ng-template>
    </div>
</ng-container>
